export enum MoreLessType {
  TEASER = 'teaser',
}
